import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Zap, Check, ShieldCheck, Award } from 'lucide-react';
const pack = {
  id: 'completo',
  icon: <Zap className="text-emerald-600" data-id="element-141" />,
  title: 'PACK COMPLETO LISTO PARA USAR',
  subtitle: '7 TOMOS + BONOS ADICIONALES INCLUIDOS',
  features: ['Todos los niveles de educación secundaria + acceso digital', 'Tomos 1 a 7 completos', 'Los 3 Bonos Estratégicos', 'Actualizaciones de por vida'],
  oldPrice: 'USD 29',
  price: 'USD 14.99',
  url: 'https://biologiaenaccion.impultienda.ar/checkout'
};
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = pack.url;
  };
  return <section id="pricing" className="py-4 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-142">
      <div className="text-center mb-4 md:mb-16" data-id="element-143">
        <h2 className="text-xl md:text-5xl font-black text-slate-900 mb-1" data-id="element-144">
          Tu <span className="text-emerald-600" data-id="element-145">MegaPack</span> Biología en
          Acción:
        </h2>
        <p className="text-slate-600 font-bold text-[10px] md:text-lg" data-id="element-146">
          Incluye los 3 Bonos Estratégicos
        </p>
      </div>

      <div className="mb-4" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="p-4 md:p-8 rounded-2xl border-2 border-emerald-600 bg-white shadow-2xl shadow-emerald-900/10 relative overflow-hidden" data-id="element-148">
          <div className="flex-1" data-id="element-149">
            <div className="flex items-center gap-2 mb-1" data-id="element-150">
              {cloneElement(pack.icon as React.ReactElement, {
              size: 20
            })}
              <h3 className="font-black text-slate-900 text-sm md:text-xl uppercase" data-id="element-151">
                {pack.title}
              </h3>
            </div>
            <p className="text-slate-500 font-bold text-[10px] md:text-sm mb-3" data-id="element-152">
              {pack.subtitle}
            </p>

            <div className="space-y-1 mb-4" data-id="element-153">
              {pack.features.map((f, i) => <div key={i} className="flex items-start gap-1.5 text-[11px] md:text-base text-slate-700 font-medium leading-tight" data-id="element-154">
                  <Check size={14} className="text-emerald-600 shrink-0 mt-0.5" data-id="element-155" />
                  <span data-id="element-156">{f}</span>
                </div>)}
            </div>

            <div className="flex items-baseline gap-2" data-id="element-157">
              {pack.oldPrice && <span className="text-slate-400 line-through font-bold text-xs md:text-lg" data-id="element-158">
                  {pack.oldPrice}
                </span>}
              <span className="md:text-4xl font-black text-slate-900 text-[24px]" data-id="element-159">
                {pack.price}
              </span>
            </div>
            <p className="text-slate-500 font-medium text-[10px] md:text-xs mt-1" data-id="element-160">
              Pago único. Sin suscripciones.
            </p>
          </div>
        </motion.div>
      </div>

      {/* PAYMENT SECURITY BLOCK — Before CTA */}
      <div className="text-center mb-3" data-id="element-161">
        <p className="text-slate-600 font-medium text-xs md:text-sm mb-2" data-id="element-162">
          Podrás pagar de forma segura con los medios habilitados para tu país:
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 mb-3" data-id="element-163">
          <span className="bg-white border border-slate-200 px-2.5 py-1 rounded-md text-[10px] md:text-xs font-bold text-[#009EE3] shadow-sm" data-id="element-164">
            Mercado Pago
          </span>
          <span className="bg-white border border-slate-200 px-2.5 py-1 rounded-md text-[10px] md:text-xs font-black text-[#1A1F71] shadow-sm tracking-wider italic" data-id="element-165">
            Visa
          </span>
          <span className="bg-white border border-slate-200 px-2.5 py-1 rounded-md text-[10px] md:text-xs font-black text-[#EB001B] shadow-sm" data-id="element-166">
            Mastercard
          </span>
        </div>
        <div className="bg-[#F0FDF4] border border-emerald-200 rounded-xl px-4 py-2.5 max-w-md mx-auto mb-3" data-id="element-167">
          <p className="text-[13px] text-emerald-800 font-bold leading-snug" data-id="element-168">
            📦 ENTREGA DIGITAL INMEDIATA: Sin costos de envío. Una vez
            acreditado el pago, recibirás las instrucciones de acceso en el
            correo electrónico utilizado durante la compra.
          </p>
        </div>
        <p className="text-slate-500 font-medium text-[11px] md:text-xs leading-snug max-w-md mx-auto" data-id="element-169">
          Al seleccionar «Acceder ahora», serás redirigido a un checkout seguro.
          Allí el precio de USD 14.99 se convertirá automáticamente a la moneda
          local disponible en tu país. Antes de confirmar la compra, podrás
          revisar el importe final y los medios de pago habilitados.
        </p>
      </div>

      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handlePurchase} className="w-full bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-lg md:text-3xl py-4 rounded-2xl shadow-[0_0_25px_rgba(34,197,94,0.4)] mb-2 uppercase tracking-tight btn-neon" data-id="element-170">
        →DESCARGARLO AHORA
      </motion.button>
      <p className="text-center text-slate-500 text-[11px] md:text-xs font-medium mb-10" data-id="element-171">
        🔒 Serás redirigido al checkout seguro para completar tu compra.
      </p>

      {/* SUPPORT ROW — 3 clean badges */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-12 max-w-3xl mx-auto" data-id="element-172">
        {[{
        icon: <ShieldCheck size={28} strokeWidth={2} data-id="element-173" />,
        title: 'Compra protegida',
        desc: 'Checkout seguro'
      }, {
        icon: <Zap size={28} strokeWidth={2} data-id="element-174" />,
        title: 'Acceso Inmediato',
        desc: 'Formato PDF'
      }, {
        icon: <Award size={28} strokeWidth={2} data-id="element-175" />,
        title: '7 Días de Garantía',
        desc: 'de Satisfacción'
      }].map((badge, i) => <div key={i} className="bg-white p-4 md:p-5 rounded-2xl border border-emerald-50 text-center flex flex-col items-center" data-id="element-176">
            <div className="text-emerald-600 mb-2" data-id="element-177">{badge.icon}</div>
            <p className="font-black text-slate-900 text-sm md:text-base leading-tight" data-id="element-178">
              {badge.title}
            </p>
            <p className="text-slate-500 text-xs font-medium mt-0.5" data-id="element-179">
              {badge.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-white p-8 rounded-[2.5rem] border border-emerald-100 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-180">
        <img src="https://cdn.magicpatterns.com/uploads/xjL7Qd7m5pdQt7z6Ki4g3Z/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-24 h-24 md:w-32 md:h-32 object-contain" data-id="element-181" />
        <div data-id="element-182">
          <h5 className="text-slate-900 font-black text-lg md:text-xl mb-1" data-id="element-183">
            Garantía de satisfacción durante 7 días
          </h5>
          <p className="text-slate-500 font-medium text-sm md:text-base" data-id="element-184">
            Si el material no responde a tus necesidades, puedes solicitar la
            devolución del 100% de tu pago dentro del periodo de garantía.
          </p>
        </div>
      </div>
    </section>;
}